import { render, staticRenderFns } from "./uploadFiledActivity.vue?vue&type=template&id=564d1332&scoped=true&"
import script from "./uploadFiledActivity.vue?vue&type=script&lang=js&"
export * from "./uploadFiledActivity.vue?vue&type=script&lang=js&"
import style0 from "./uploadFiledActivity.vue?vue&type=style&index=0&id=564d1332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d1332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('564d1332')) {
      api.createRecord('564d1332', component.options)
    } else {
      api.reload('564d1332', component.options)
    }
    module.hot.accept("./uploadFiledActivity.vue?vue&type=template&id=564d1332&scoped=true&", function () {
      api.rerender('564d1332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/components/uploadFiledActivity.vue"
export default component.exports